import request from '@/plugins/axios'

//获取角色列表
export function listAuthRole(params) {
  return request({
    url: '/authRole/listAuthRole',
    method: 'get',
    params
  })
}

//添加角色
export function addAuthRole(data) {
  return request({
    url: '/authRole/addAuthRole',
    method: 'post',
    data
  })
}

//删除角色
export function deleteAuthRole(params) {
  return request({
    url: '/authRole/deleteAuthRole/' + params,
    method: 'get'
  })
}

//查询单个角色
export function getAuthRole(params) {
  return request({
    url: '/authRole/getAuthRole/' + params,
    method: 'get'
  })
}

//修改角色信息
export function updateAuthRole(data) {
  return request({
    url: '/authRole/updateAuthRole',
    method: 'post',
    data
  })
}


//获取权限节点模板
export function getPowerTemplate() {
  return request({
    url: '/authRole/getPowerTemplate',
    method: 'get'
  })
}

//获取角色权限列表
export function getPowers(params) {
  return request({
    url: '/authRole/getPowers/' + params,
    method: 'get'
  })
}

//角色授权
export function setPowers(params,data) {
  return request({
    url: '/authRole/setPowers/' + params,
    method: 'post',
    data
  })
}


//查询单个角色绑定的用户列表
export function getAuthRoleAccess(params) {
  return request({
    url: '/authRole/getAuthRoleAccess',
    method: 'get',
    params
  })
}

//删除用户的角色关联
export function deleteAuthRoleAccess(params) {
  return request({
    url: '/authRole/deleteAuthRoleAccess',
    method: 'get',
    params
  })
}